/**
 * @Description: OME订单接口-路由
 * @author DYD
 * @date 2025/8/6
 */
import {h, KeepAlive} from 'vue'
import {RouterView} from 'vue-router'

export const OemRoutes = [
  {
    path: '/oem',
    component: RouterView,
    children: [
      {
        path: ':uuid',
        component: {
          render () {
            return h(RouterView, null, {
              default: ({Component}) =>
                h(KeepAlive, null, {
                  default: () => h(Component),
                }),
            })
          },
        },
        children: [
          /**
           * OME置换报告
           * path oem/:uuid/purchase
           */
          {
            path: 'purchase',
            name: 'OEMPurchaseReport',
            component: () => import('@pages/oem-order-purchase-report/index.vue'),
            meta: {
              title: '收购报告',
            },
          },
        ],
      },
    ],
  },
]
